import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Row from '../../../node_modules/reactstrap/esm/Row.js';
import Col from '../../../node_modules/reactstrap/esm/Col.js';
import Theme from '../../../Theme/index.js';

var _templateObject, _templateObject2, _templateObject3;
var _Theme$colors = Theme.colors,
  pearlGrey = _Theme$colors.pearlGrey,
  lightBlue = _Theme$colors.lightBlue,
  white = _Theme$colors.white;
var NPSScoreRange = 11;
var Lead = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  font-weight: 400;\n  text-align: ", ";\n"])), function (props) {
  return props.right && "right";
});
var ScoreWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  left: 1px;\n  position: relative;\n  width: 100%;\n  margin-bottom: 0.5rem;\n"])));
var ScoreBoxHolder = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  margin-left: -1px;\n  position: relative;\n\n  border: 1px solid ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor: pointer;\n  z-index: ", ";\n\n  &:hover {\n    border-color: ", ";\n    z-index: 9;\n  }\n\n  &::before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n  }\n\n  span {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    text-align: center;\n    transform: translateY(-50%);\n    font-size: 0.875rem;\n    font-weight: 600;\n  }\n"])), function (props) {
  return props.selected ? lightBlue : pearlGrey;
}, function (props) {
  return props.selected && white;
}, function (props) {
  return props.selected && lightBlue;
}, function (props) {
  return props.selected && "9";
}, lightBlue);
var ScoreBox = function ScoreBox(_ref) {
  var score = _ref.score,
    selected = _ref.selected,
    onClickHandler = _ref.onClickHandler;
  return /*#__PURE__*/React__default.createElement(ScoreBoxHolder, {
    selected: selected,
    onClick: function onClick() {
      return onClickHandler(score);
    }
  }, /*#__PURE__*/React__default.createElement("span", null, score));
};
var ScoreCol = function ScoreCol(_ref2) {
  var onScoreClick = _ref2.onScoreClick,
    score = _ref2.score;
  return /*#__PURE__*/React__default.createElement(Col, {
    md: "6"
  }, /*#__PURE__*/React__default.createElement("p", null, "How likely are you to recommend this version of PGA.org to other Members?"), /*#__PURE__*/React__default.createElement(ScoreWrapper, null, Array(NPSScoreRange).fill(0).map(function (_, ix) {
    return /*#__PURE__*/React__default.createElement(ScoreBox, {
      score: ix,
      key: "score-box-".concat(ix),
      selected: score === ix,
      onClickHandler: onScoreClick
    });
  })), /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Col, {
    xs: "6"
  }, /*#__PURE__*/React__default.createElement(Lead, null, "Not at all likely")), /*#__PURE__*/React__default.createElement(Col, {
    xs: "6"
  }, /*#__PURE__*/React__default.createElement(Lead, {
    right: "1"
  }, "Extremely likely"))));
};
ScoreCol.propTypes = {
  onScoreClick: PropTypes.func.isRequired,
  score: PropTypes.number
};

export { ScoreCol as default };
